import type { Credential } from '../interfaces/user.interface';

/** "2026" when no expiry, "2026–2029" (en dash) when a validity range is set. */
export function formatCredentialYears(
  c: Pick<Credential, 'year' | 'expiryYear'>,
): string {
  return c.expiryYear != null ? `${c.year}–${c.expiryYear}` : String(c.year);
}
